import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

const selectors = {
  slider: "[data-cards]",
};

const initSwiper = (container) =>
  new Swiper(container.querySelector(".swiper"), {
    slidesPerView: "auto",
    spaceBetween: 24,

    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
    },

    navigation: {
      prevEl: container.querySelector(".swiper-navigation.prev"),
      nextEl: container.querySelector(".swiper-navigation.next"),
    },

    pagination: {
      el: container.querySelector(".swiper-pagination"),
    },
  });

const init = (container) => {
  Swiper.use([Navigation, Pagination]);

  initSwiper(container);
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const containers = document.querySelectorAll(selectors.slider);

    containers?.forEach(init);
  },
  {
    once: true,
  }
);
